import { css } from '@emotion/react';
import styled from '@emotion/styled';
import { Button } from '@presentation/components/Button';
import { BREAKPOINTS, mediaQuery } from '@presentation/styles';
import { Link } from 'react-router-dom';
import type { HeaderColor } from '.';
import { Container } from '../Container';

export const Wrapper = styled.div<{ color: HeaderColor; showStickyBlueBanner: boolean }>`
  line-height: 1.2;

  position: fixed;
  top: 0;
  width: 100%;
  z-index: 100;
  height: ${(props) => (props.showStickyBlueBanner ? '119px' : '80px')};

  background-color: ${(props) => props.theme.color[props.color].default};
`;

export const NavContainer = styled(Container)<{ showStickyBlueBanner: boolean }>`
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 100%;
  padding: ${(props) => (props.showStickyBlueBanner ? ' 0 40px 32px 40px' : '0 40px')} !important;
  ${mediaQuery('phone')} {
    padding: ${(props) =>
      props.showStickyBlueBanner ? '  0 40px 28px 40px' : '0 40px'} !important;
  }
`;

export const logoStyle = css`
  height: 80px;
  max-width: 140px;
  cursor: pointer;
  padding-right: 15px;
`;

export const MainContainer = styled.div<{ hideOnMobile: boolean }>`
  display: flex;
  align-items: center;
  ${mediaQuery(BREAKPOINTS.header)} {
    display: ${(props) => (props.hideOnMobile ? 'none' : 'inherit')};
  }
`;

export const languageSelectorStyle = css`
  margin-left: 15px;
`;

export const MainLink = styled.div<{ headercolor: HeaderColor }>`
  display: block;
  font-weight: 500;
  font-size: 16px;
  position: relative;
  display: inline-block;
  cursor: pointer;
  padding: 10px 15px;
  transition: all 0.2s ease-in-out;
  ${(props) => props.headercolor !== 'light' && 'font-weight: 600;'}
  color: ${(props) =>
    props.headercolor === 'light'
      ? props.theme.color.dark.default
      : props.theme.color.light.default};
  &:hover {
    color: ${(props) =>
      props.headercolor === 'light'
        ? props.theme.color.blue.default
        : props.theme.color.light.default};
  }
  &:hover > div {
    display: block;
  }
`;

export const LinkDropdownContent = styled.div<{ headercolor: HeaderColor }>`
  overflow: hidden;

  display: none;
  transition: height 0ms 300ms;

  background: ${(props) =>
    props.headercolor === 'light'
      ? props.theme.color.blue.default
      : props.theme.color.light.default};
  position: absolute;
  transform: translateX(-50%);
  z-index: 1;
  left: 50%;
  margin-top: 10px;
  border-radius: 10px;
  min-width: 250px;
  text-align: center;
  box-shadow: 0 10px 10px rgba(0, 0, 0, 0.08);
`;

export const SubLink = styled(Link)<{ headercolor: HeaderColor }>`
  display: block;
  white-space: nowrap;
  font-weight: 400;
  transition: background 0.3s ease-in-out;
  padding: 10px 30px;
  position: relative;

  color: ${(props) =>
    props.headercolor === 'light'
      ? props.theme.color.light.default
      : props.theme.color[props.headercolor].default};

  cursor: pointer;
  &:hover::after {
    background-color: ${(props) =>
      props.headercolor === 'light' ? 'rgba(255, 255, 255, 0.1)' : 'rgba(0, 0, 0, 0.075)'};
    bottom: 0;
    content: '';
    height: 100%;
    left: 0;
    position: absolute;
    right: 0;
    top: 0;
    width: 100%;
  }
`;

export const ButtonStyled = styled(Button)<{ headercolor: HeaderColor }>`
  display: inline-block;
  width: auto;
  margin: 0px 5px;
  ${(props) =>
    props.headercolor === 'purple' && `color: ${props.theme.color.purple.default} !important;`}
`;

export const StoreLink = styled.div`
  display: inline-flex;
  width: auto;
  margin: 0px 5px;
  font-weight: 500;
  font-size: 16px;
  position: relative;
  cursor: pointer;
  padding: 10px 15px;
  background: ${(props) => props.theme.color.blue.lightBlue};
  color: ${(props) => props.theme.color.blue.default};
  border-radius: 15px;
`;

export const StoreIcon = styled.img`
  width: 20px;
  margin-left: 5px;
`;

export const LeftSideItems = styled.div`
  display: flex;
`;
export const BlueBanner = styled.div`
  font-family: ${(props) => props.theme.font.assistant};
  letter-spacing: 1px;
  align-content: center;
  text-align: center;

  cursor: pointer;

  width: 100%;
  height: 39px;
  font-weight: 600;
  background-color: #0a1437;
  color: ${(props) => props.theme.color.light.default};
  font-size: 13px;
  ${mediaQuery('phone')} {
    display: flex;
    flex-direction: column;
    justify-content: center;
    font-size: 12px;
  }
`;

export const BlueBannerCta = styled.span`
  font-family: ${(props) => props.theme.font.assistant};
  letter-spacing: 1px;
  font-weight: 700;
  font-size: 13px;
  color: ${(props) => props.theme.color.light.default};
  ${mediaQuery('phone')} {
    font-size: 12px;
  }
`;
